<div class="outbidded-message">
  <div class="outbidded-message__bg" (click)="closeModal()"></div>
  <div class="outbidded-message__content">
    <div class="modal-header">
      <h5 class="modal-title">დაფიქსირდა შეცდომა</h5>
      <button type="button" class="close" (click)="closeModal()">
        <img src="/assets/images/close.svg" alt="X" />
      </button>
    </div>
    <div class="p-3">
      <p *ngFor="let errorMessage of data">{{ errorMessage }}</p>
      <div class="text-center">
        <button class="btn btn-success py-2 px-3 mt-2" (click)="closeModal()">
          დახურვა
        </button>
      </div>
    </div>
  </div>
</div>
